import {
  FETCH_CLIENT,
  FETCH_CLIENT_DONE,
  FETCH_CLIENT_ERROR,
  FETCH_GEO_LOCATION,
  FETCH_GEO_LOCATION_DONE,
  FETCH_GEO_LOCATION_ERROR,
  FETCH_CLIENT_BRANDING,
  FETCH_CLIENT_BRANDING_DONE,
  FETCH_CLIENT_BRANDING_ERROR,
  FETCH_CLIENT_NETWORK,
  FETCH_CLIENT_NETWORK_DONE,
  FETCH_CLIENT_NETWORK_ERROR,
  LOCATION_ALLOW_BLOCK
} from "./constants";

export const fetchClient = (shortName) => ({
  type: FETCH_CLIENT,
  shortName
});

export const fetchClientDone = (payload) => ({
  type: FETCH_CLIENT_DONE,
  payload
});

export const fetchClientError = (error) => ({
  type: FETCH_CLIENT_ERROR,
  error
});

export const fetchGeoLoc = (position) => ({
  type: FETCH_GEO_LOCATION,
  position
});

export const fetchGeoLocDone = (payload) => ({
  type: FETCH_GEO_LOCATION_DONE,
  payload
});

export const fetchGeoLocError = (error) => ({
  type: FETCH_GEO_LOCATION_ERROR,
  error
});

export const fetchClientBranding = (username) => ({
  type: FETCH_CLIENT_BRANDING,
  username
});

export const fetchClientBrandingDone = (payload) => ({
  type: FETCH_CLIENT_BRANDING_DONE,
  payload
});

export const fetchClientBrandingError = (error) => ({
  type: FETCH_CLIENT_BRANDING_ERROR,
  error
});

export const fetchClientNetwork = (username) => ({
  type: FETCH_CLIENT_NETWORK,
  username
});

export const fetchClientNetworkDone = (payload) => ({
  type: FETCH_CLIENT_NETWORK_DONE,
  payload
});

export const fetchClientNetworkError = (error) => ({
  type: FETCH_CLIENT_NETWORK_ERROR,
  error
});

export const userLocationAllowBlock = (decision) => ({
  type: LOCATION_ALLOW_BLOCK,
  payload: decision
});
